/**
 * Cart quantity jump enforcement
 *
 * The +/- buttons rely on the native stepUp() / stepDown() methods,
 * which already respect the <input step="N"> attribute we set in Liquid.
 *
 * This script only handles the case where a customer types a value
 * directly: on `change` it rounds UP to the nearest multiple of step
 * and caps the result at the inventory/rule max.
 *
 * Runs in capture phase so the value is corrected before cart.js
 * bubble-phase handlers fire — the cart therefore always receives
 * the already-rounded quantity.
 */
(function () {
  if (window.__cartQtyJumpLoaded) return;
  window.__cartQtyJumpLoaded = true;

  function getStep(input) {
    return Math.max(1, parseInt(input.dataset.quantityJump, 10) || 1);
  }

  function getMax(input) {
    const attr = input.getAttribute('max');
    return attr !== null && attr !== '' ? parseInt(attr, 10) : Infinity;
  }

  function enforce(input) {
    const step = getStep(input);
    if (step <= 1) return; // nothing to enforce for step=1

    const max = getMax(input);
    const raw = parseInt(input.value, 10);

    if (isNaN(raw) || raw <= 0) return; // let theme handle 0 / empty

    // Round up to nearest multiple of step
    const snapped = Math.ceil(raw / step) * step;

    // Cap: highest multiple of step that still fits within max
    const capped = isFinite(max)
      ? Math.min(snapped, Math.floor(max / step) * step)
      : snapped;

    if (String(input.value) !== String(capped)) {
      input.value = capped;
    }
  }

  document.addEventListener(
    'change',
    function (e) {
      const input = e.target;
      if (
        input.classList.contains('quantity__input') &&
        input.dataset.quantityJump
      ) {
        enforce(input);
      }
    },
    true // capture — runs before cart.js bubble listeners
  );
})();
